import React, { useEffect, useState, useRef } from "react";
import {
  tableRowSx,
  tableContainerSx,
  tableHeaderSx,
} from "services/constants";
import { viewLeaveTypeDetails } from "pages/HR/Headers";
import { Edit, FileCopy } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { tableData } from "services/constants/Styles";
import * as Mui from "@mui/material";
import { useDispatch } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { AddLeaveTypeConfig } from "./AddLeaveTypeConfig";
import { EditLeaveTypeConfig } from "./EditLeaveTypeConfig";
import { CloneLeaveTypeConfig } from "./CloneLeaveTypeConfig";
import { Loader } from "components/Loader";
import dayjs from "dayjs";
import { showToast } from "services/utils/Status";

const leaveTypeIndividualKey = [
  "version",
  "effective_from",
  "effective_to",
  "proportionate_leaves_on_joined_date",
  "is_paid_leave",
  "payment_factor",
  "leave_crediting_schedule",
  "leave_per_leave_period",
  "is_week_off_rule_apply",
  "is_holiday_rule_apply",
  "leave_pay_out_policy",
  "no_of_days_leave_carry_forward",
  "expiry_month",
  "last_credited_date",
];

const leaveTypeTableSx = {
  minWidth: 1600,
  "& .MuiTableCell-root": {
    whiteSpace: "normal",
    verticalAlign: "top",
  },
};

const leaveTypeContainerSx = {
  ...tableContainerSx,
  width: "calc(100% - 32px)",
  boxSizing: "border-box",
  overflowX: "auto",
};
export const ViewLeaveType = ({
  viewDetails,
  setShowViewDetails,
  setApiCallForLeaveType,
}) => {
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [editLeaveTypeDetails, setEditLeaveTypeDetails] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [cloneLeaveType, setCloneLeaveType] = useState(false);
  const {
    result: masterLeaveTypeConfig,
    loading,
    setLoad: setApiCall,
  } = useFetch(
    `${domain}configuration-leave-type/?leave_type_id=${viewDetails?.id}`
  );
  const dispatch = useDispatch();
  const [editLeaveType, setEditLeaveType] = useState(false);
  const [addLeaveTypeConfig, setAddLeaveTypeConfig] = useState(false);
  const [leaveTypesConfig, setLeaveTypesConfig] = useState([]);
  const [initalTrigger, setInitialTrigger] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (initalTrigger && !loading) {
      setLeaveTypesConfig(masterLeaveTypeConfig);
      setInitialTrigger(false);
    }
  }, [initalTrigger, loading, masterLeaveTypeConfig]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  useEffect(() => {
    if (!loading) {
      const filteredResults = masterLeaveTypeConfig.filter((item) =>
        leaveTypeIndividualKey.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );

      setLeaveTypesConfig(filteredResults);
      setPage(globalSearchValue ? 0 : page);
    }
  }, [globalSearchValue, initalTrigger, loading, masterLeaveTypeConfig, page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <BackArrow
          actionFunction={() => {
            if (!editLeaveType) {
              setShowViewDetails(false);
              setApiCallForLeaveType(true);
              dispatch(setGlobalSearchValue(""));
            } else {
              setEditLeaveType(false);
            }
          }}
        />

        <Mui.Typography
          sx={{
            paddingTop: 1,
            fontSize: 20,
            fontWeight: "bold",
          }}
        >
          Leave Type / {viewDetails?.name}
        </Mui.Typography>
      </Mui.Grid>
      {masterLeaveTypeConfig?.length !== 0 &&
      !addLeaveTypeConfig &&
      !editLeaveType &&
      !cloneLeaveType ? (
        <Mui.TableContainer ref={containerRef} sx={leaveTypeContainerSx}>
          <Mui.Table sx={leaveTypeTableSx}>
            <Mui.TableHead sx={tableHeaderSx}>
              <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                {viewLeaveTypeDetails?.map((head) => (
                  <Mui.TableCell sx={tableData}>{head.name}</Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {leaveTypesConfig?.length === 0 ? (
                <TableEmptyState dataLength={masterLeaveTypeConfig} />
              ) : (
                leaveTypesConfig
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((item, index) => (
                    <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                      {viewLeaveTypeDetails.map((head) =>
                        head.name !== "Action" ? (
                          <Mui.TableCell sx={tableRowSx}>
                            {head.key === "effective_from" ||
                            head.key === "effective_to" ||
                            head.key === "last_credited_date"
                              ? item[head.key]
                                ? dayjs(item[head.key]).format("DD/MM/YYYY")
                                : "N/A"
                              : item[head.key] === true
                              ? "Yes"
                              : item[head.key] === false
                              ? "No"
                              : item[head.key] || item[head.key] === 0
                              ? item[head.key]
                              : "N/A"}
                          </Mui.TableCell>
                        ) : (
                          <Mui.TableCell sx={tableData}>
                            {item?.is_cloneable || item?.is_editable ? (
                              <Mui.Stack direction="row">
                                {item["last_credited_date"] ? (
                                  <Mui.IconButton
                                    onClick={() => {
                                      if (
                                        checkEditorPermission(
                                          userScreenAccess?.module_details,
                                          "LMS",
                                          "Leave Type"
                                        )
                                      ) {
                                        setEditLeaveTypeDetails(item);
                                        setCloneLeaveType(true);
                                      } else {
                                        showToast(
                                          "error",
                                          "Access denied: You are not authorized to clone this leave type"
                                        );
                                      }
                                    }}
                                  >
                                    <FileCopy />
                                  </Mui.IconButton>
                                ) : (
                                  <Mui.IconButton
                                    onClick={() => {
                                      if (
                                        checkEditorPermission(
                                          userScreenAccess?.module_details,
                                          "LMS",
                                          "Leave Type"
                                        )
                                      ) {
                                        setEditLeaveType(true);
                                        setEditLeaveTypeDetails(item);
                                      } else {
                                        showToast(
                                          "error",
                                          "Access denied: You are not authorized to edit this leave type"
                                        );
                                      }
                                    }}
                                  >
                                    <Edit />
                                  </Mui.IconButton>
                                )}
                              </Mui.Stack>
                            ) : null}
                          </Mui.TableCell>
                        )
                      )}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
          {leaveTypesConfig?.length > 25 ? (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={leaveTypesConfig.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          ) : null}
        </Mui.TableContainer>
      ) : addLeaveTypeConfig ? (
        <AddLeaveTypeConfig
          viewDetails={viewDetails}
          setApiCall={setApiCall}
          setAddLeaveTypeConfig={setAddLeaveTypeConfig}
        />
      ) : !editLeaveType && !cloneLeaveType ? (
        <Mui.Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: "80vh" }}
        >
          <CustomButton
            actionFuntion={() => {
              if (
                checkEditorPermission(
                  userScreenAccess?.module_details,
                  "LMS",
                  "Leave Type"
                )
              ) {
                setAddLeaveTypeConfig(true);
              } else {
                showToast(
                  "error",
                  "Access denied: You are not authorized to add new configuration"
                );
              }
            }}
            actionName="Add new configuration"
            typeName="button"
          />
        </Mui.Grid>
      ) : editLeaveType ? (
        <EditLeaveTypeConfig
          viewDetails={viewDetails}
          editLeaveTypeDetails={editLeaveTypeDetails}
          setEditLeaveType={setEditLeaveType}
          setApiCall={setApiCall}
        />
      ) : cloneLeaveType ? (
        <CloneLeaveTypeConfig
          viewDetails={viewDetails}
          editLeaveTypeDetails={editLeaveTypeDetails}
          setCloneLeaveType={setCloneLeaveType}
          setApiCall={setApiCall}
        />
      ) : null}
    </React.Fragment>
  );
};
